import { redirect } from 'react-router-dom';
import { getRenewalNotificationService } from 'services/renewal-notification';
import { isAuthed } from 'utils/common/session';

export const renewalNotificationQueryKeys = {
  all: ['renewal-notification'],
  detail: (userId) => [
    ...renewalNotificationQueryKeys.all,
    'detail',
    parseInt(userId),
  ],
};

export const prefetchRenewalNotificationQuery = async (queryClient, userId) => {
  await queryClient.prefetchQuery({
    queryKey: renewalNotificationQueryKeys.detail(userId),
    queryFn: async () => {
      const response = await getRenewalNotificationService();
      if (!response?.isSuccess) {
        throw new Error('Failed to fetch Renewal Notification');
      }
      return response.data;
    },
  });
};

export const getRenewalNotificationFromCache = (queryClient, userId) => {
  return queryClient.getQueryData(renewalNotificationQueryKeys.detail(userId));
};

export const ensureRenewalNotificationData = async (queryClient, userId) => {
  // Early return if not authenticated or no userId
  if (!isAuthed() || !userId) {
    throw new Error('User not authenticated or userId missing');
  }

  try {
    const renewalNotificationData = await queryClient.ensureQueryData({
      queryKey: renewalNotificationQueryKeys.detail(userId),
      queryFn: async () => {
        const response = await getRenewalNotificationService();
        return response?.data;
      },
    });

    return renewalNotificationData;
  } catch (error) {
    throw error;
  }
};

export const validateRenewalNotificationFlow = async ({
  queryClient,
  userId,
  returnUrl,
}) => {
  try {
    const eulaData = await ensureRenewalNotificationData(queryClient, userId);
    const isRenewalNotificationAccepted = eulaData?.isAccepted;

    if (!isRenewalNotificationAccepted) {
      throw redirect(`/eula?returnUrl=${encodeURIComponent(returnUrl)}`);
    }
  } catch (error) {
    if (error?.status === 302 || error instanceof Response) {
      throw error;
    }
  }
};
